import {Controller} from "stimulus";
import {fetchJson} from "../../assets/request";
import navigationHelper from "../../assets/navigation-helper";

export default class extends Controller {
  connect() {
    this.poll();
  }

  poll() {
    fetchJson("/customercontrol/customerdata/ajax-has-unconfirmed-changes/", {
      method: 'POST'
    })
      .then((response) => {
        if (response.has_unconfirmed_changes !== false) {
          return Promise.reject();
        }
        navigationHelper.reload();
      }).catch(() => setTimeout(() => this.poll(), 5000));
  }
}
